<template>
  <BContainer
    v-if="currentUser"
    class="mb-4"
  >
    <div class="d-flex justify-content-end">
      <BBreadcrumb
        v-if="$route.meta.breadcrumb"
        :items="$route.meta.breadcrumb || []"
      />
    </div>

    <BSidebar
      id="sbRsmCustomer"
      backdrop-variant="dark"
      backdrop
      shadow
      right
    >
      <template #title>
        <i class="fad fa-filter-list" /> Filters
      </template>

      <BContainer>
        <BRow>
          <BCol
            cols="12"
          >
            <BFormGroup
              label="Area"
              label-for="filterArea"
              label-class="font-weight-bolder"
              class="mb-2"
            >
              <VSelect
                v-model="tableCustomers.selected.area"
                placeholder="filter area here"
                input-id="filterArea"
                label="area_name"
                class="border border-light rounded-lg"
                clearable
                append-to-body
                :options="(tableCustomers.options.areas)"
                :loading="(tableCustomers.fetching.areas)"
                :disabled="(tableCustomers.busy || tableCustomers.fetching.areas)"
                :calculate-position="calculateDropPosition"
                @search="searchFilterAreas"
              >
                <template #no-options="">
                  no available area
                </template>
              </VSelect>
            </BFormGroup>
          </BCol>

          <BCol
            cols="12"
          >
            <BFormGroup
              label="Cluster"
              label-for="filterCluster"
              label-class="font-weight-bolder"
              class="mb-2"
            >
              <VSelect
                v-model="tableCustomers.selected.cluster"
                placeholder="filter cluster here"
                input-id="filterCluster"
                label="cluster_name"
                class="border border-light rounded-lg"
                clearable
                append-to-body
                :options="(tableCustomers.options.clusters)"
                :loading="(tableCustomers.fetching.clusters)"
                :disabled="(tableCustomers.busy || tableCustomers.fetching.clusters)"
                :calculate-position="calculateDropPosition"
                @search="searchFilterClusters"
              >
                <template #no-options="">
                  no available cluster
                </template>
              </VSelect>
            </BFormGroup>
          </BCol>
          <BCol
            cols="12"
          >
            <BFormGroup
              label="Officer"
              label-for="filterOfficer"
              label-class="font-weight-bolder"
              class="mb-2"
            >
              <VSelect
                v-model="tableCustomers.selected.fsOfficer"
                placeholder="filter officer here"
                input-id="filterOfficer"
                label="officer_name"
                clearable
                append-to-body
                :options="(tableCustomers.options.fsOfficers)"
                :loading="(tableCustomers.fetching.fsOfficers)"
                :disabled="(tableCustomers.busy || tableCustomers.fetching.fsOfficers)"
                :calculate-position="calculateDropPosition"
                @search="searchFilterFSOfficers"
              >
                <template #option="{ officer_name, mobile_number, photos }">
                  <div class="d-flex flex-column flex-md-row py-1">
                    <div class="flex-grow-1 d-flex align-items-center">
                      <div class="mr-2">
                        <BAvatar
                          v-if="photos && photos.length > 0"
                          :src="getCustomerProfile(photos)"
                          variant="primary"
                          size="28px"
                        />
                        <BAvatar
                          v-else
                          :text="String(officer_name).charAt(0)"
                          variant="primary"
                          size="28px"
                        />
                      </div>
                      <div class="d-flex flex-column">
                        <div
                          class="text-break text-wrap"
                          v-text="officer_name"
                        />
                        <strong>{{ mobile_number || '' }}</strong>
                      </div>
                    </div>
                  </div>
                </template>
                <template #selected-option="{ officer_name, photos }">
                  <div class="d-flex flex-column flex-md-row">
                    <div class="flex-grow-1 d-flex align-items-center">
                      <div class="mr-2">
                        <BAvatar
                          v-if="photos && photos.length > 0"
                          :src="getCustomerProfile(photos)"
                          variant="primary"
                          size="28px"
                        />
                        <BAvatar
                          v-else
                          :text="String(officer_name).charAt(0)"
                          variant="primary"
                          size="28px"
                        />
                      </div>
                      <div
                        class="text-truncate"
                        v-text="officer_name"
                      />
                    </div>
                  </div>
                </template>
                <template #no-options="">
                  no available officer
                </template>
              </VSelect>
            </BFormGroup>
          </BCol>
          <BCol
            cols="12"
          >
            <BFormGroup
              label="Province"
              label-for="filterProvince"
              label-class="font-weight-bolder"
              class="mb-2"
            >
              <VSelect
                v-model="tableCustomers.selected.province"
                placeholder="filter province here"
                input-id="filterProvince"
                label="province_name"
                class="border border-light rounded-lg"
                clearable
                append-to-body
                :options="(tableCustomers.options.provinces)"
                :loading="(tableCustomers.fetching.provinces)"
                :disabled="(tableCustomers.busy || tableCustomers.fetching.provinces)"
                :calculate-position="calculateDropPosition"
                @search="searchFilterProvinces"
              >
                <template #option="{ province_name, region }">
                  <div
                    class="text-break text-wrap"
                    v-text="province_name"
                  />
                  <div
                    class="text-muted small"
                    v-text="region.region_name"
                  />
                </template>
                <template #selected-option="{ province_name }">
                  <div
                    class="text-break text-wrap"
                    v-text="province_name"
                  />
                </template>
                <template #no-options="">
                  no available province
                </template>
              </VSelect>
            </BFormGroup>
          </BCol>
          <BCol
            cols="12"
          >
            <BFormGroup
              label="Municipality"
              label-for="filterMunicipality"
              label-class="font-weight-bolder"
              class="mb-2"
            >
              <VSelect
                v-model="tableCustomers.selected.municipality"
                placeholder="filter municipality here"
                input-id="filterMunicipality"
                label="municipality_name"
                class="border border-light rounded-lg"
                clearable
                append-to-body
                :options="(tableCustomers.options.municipalities)"
                :loading="(tableCustomers.fetching.municipalities)"
                :disabled="(tableCustomers.busy || tableCustomers.fetching.municipalities || tableCustomers.fetching.provinces)"
                :calculate-position="calculateDropPosition"
                @search="searchFilterMunicipalities"
              >
                <template #option="{ municipality_name }">
                  <div
                    class="text-break text-wrap"
                    v-text="municipality_name"
                  />
                </template>
                <template #selected-option="{ municipality_name }">
                  <div
                    class="text-break text-wrap"
                    v-text="municipality_name"
                  />
                </template>
                <template #no-options="">
                  no available municipality
                </template>
              </VSelect>
            </BFormGroup>
          </BCol>
          <BCol
            cols="12"
          >
            <BFormGroup
              label="Status"
              label-for="filterStatus"
              label-class="font-weight-bolder"
              class="mb-2"
            >
              <BFormSelect
                id="filterStatus"
                v-model="tableCustomers.filter.status"
                :options="tableCustomers.options.statuses"
              >
                <template #first>
                  <BFormSelectOption
                    value=""
                    disabled
                    v-text="' - - filter here - - '"
                  />
                </template>
              </BFormSelect>
            </BFormGroup>
          </BCol>
          <BCol
            cols="12"
          >
            <BFormGroup
              class="mb-0"
            >
              <BFormCheckbox
                id="filterHasFarm"
                v-model="tableCustomers.filter.has_farm"
                switch
                value="1"
                name="active"
                unchecked-value="0"
                :disabled="state.busy"
              >
                Has Farm?
              </BFormCheckbox>
            </BFormGroup>
          </BCol>
          <BCol
            cols="12"
          >
            <BFormGroup
              class="mb-0"
            >
              <BFormCheckbox
                id="filterHasCrops"
                v-model="tableCustomers.filter.has_crops"
                switch
                value="1"
                name="active"
                unchecked-value="0"
                :disabled="state.busy"
              >
                Has Crops?
              </BFormCheckbox>
            </BFormGroup>
          </BCol>
        </BRow>
      </BContainer>
    </BSidebar>

    <BRow
      class="py-2"
    >
      <BCol
        cols="12"
      >
        <BFormGroup
          label="Search"
          label-for="filterSearch"
          label-class="font-weight-bolder"
          class="mb-2"
        >
          <BInputGroup>
            <BFormInput
              id="filterSearch"
              v-model="tableCustomers.filter.search"
              placeholder="search here"
              autocomplete="off"
              debounce="1000"
              type="text"
            />
            <BInputGroupAppend>
              <BButton
                v-b-toggle.sbRsmCustomer
                variant="primary"
              >
                <i
                  v-if="[settingFilters, tableCustomers.fetching.clusters, tableCustomers.fetching.fsOfficers, tableCustomers.fetching.provinces, tableCustomers.fetching.municipalities].some(trueOrFalse => trueOrFalse)"
                  class="fad fa-spinner fa-spin p-0"
                />
                <i
                  v-else
                  class="fad fa-filter-list"
                /> Filters
              </BButton>
            </BInputGroupAppend>
          </BInputGroup>
        </BFormGroup>
      </BCol>
    </BRow>

    <CustomTable
      ref="tableCustomers"
      class="mt-3"
      :provider="tableProvider"
      :fields="tableCustomers.fields"
      :filter="tableCustomers.filter"
      :filter-on="tableCustomers.filterOn"
      :sort-by="tableCustomers.sortBy"
      :sort-desc="tableCustomers.sortDesc"
      :sort-direction="tableCustomers.sortDirection"
      :total-rows="tableCustomers.totalRows"
      :current-page="tableCustomers.currentPage"
      :per-page="tableCustomers.perPage"
      :stacked="tableCustomers.stacked"
      :busy="tableCustomers.busy"
    >

      <template #cell(action)="{ item }">
        <div class="text-md-nowrap d-flex flex-column flex-md-row justify-content-center">
          <BButton
            size="sm"
            variant="primary"
            :disabled="tableCustomers.busy"
            :to="{
              name: 'audit.customers.profile',
              params: {
                customer: item.id
              }
            }"
          >
            Manage
          </BButton>
        </div>
      </template>

      <template #cell(status)="{ value }">
        <BBadge
          class="w-60px"
          :variant="`${customerStatus(value)}-light`"
          pill
          v-text="value"
        />
      </template>
    </CustomTable>

  </BContainer>
</template>
<script>
import QUERY from 'lodash'
import { mapGetters } from 'vuex'
import { setTableOptions, getTableOptions } from '@/forage/audit/customers'

import MxMisc from '@/mixins/misc'
import MxFormatter from '@/mixins/formatter'
import MxImageUrl from '@/mixins/image-url'
import MAreas from '@/mixins/locations/areas'
import MClusters from '@/mixins/locations/clusters'
import MFSOfficers from '@/mixins/accounts/fsos'
import MProvinces from '@/mixins/locations/provinces'
import MMunicipalities from '@/mixins/locations/municipalities'

import { SAuditCustomer } from '@/services/audit'

export default {

  name: 'VAuditCustomers',

  mixins: [
    MAreas,
    MClusters,
    MFSOfficers,
    MProvinces,
    MMunicipalities,
    MxMisc,
    MxFormatter,
    MxImageUrl
  ],

  beforeRouteEnter (_to, _from, navigate) {
    getTableOptions().then(options => {
      navigate(context => {
        if (context.currentUser) {
          if (options) {
            const { currentPage, perPage, sortBy, sortDesc, totalRows, filter } = options

            context.tableCustomers = Object.assign(context.tableCustomers, {
              totalRows: totalRows,
              sortBy: sortBy,
              sortDesc: sortDesc,
              perPage: perPage,
              currentPage: currentPage,
              filter: {
                search: filter.search || '',
                province: '',
                municipality: '',
                area: '',
                cluster: '',
                officer: '',
                status: filter.status || 'All',
                has_farm: filter.has_farm || 0,
                has_crops: filter.has_crops || 0
              },
              editable: {
                province: filter.province,
                municipality: filter.municipality,
                area: filter.area,
                cluster: filter.cluster,
                fsOfficer: filter.officer
              }
            })
          } else {
            context.tableCustomers.currentPage = 1
          }

          context.$nextTick(() => {
            context.getAreas(context.tableCustomers).finally(() => {
              if (context.tableCustomers.editable.area) {
                context.tableCustomers.selected.area = QUERY.find(context.tableCustomers.options.areas, {
                  id: context.tableCustomers.editable.area
                }) || ''

                context.tableCustomers.editable.area = ''
              } else {
                context.getClusters(context.tableCustomers).finally(() => {
                  if (context.tableCustomers.editable.cluster) {
                    context.tableCustomers.selected.cluster = QUERY.find(context.tableCustomers.options.clusters, {
                      id: context.tableCustomers.editable.cluster
                    }) || ''

                    context.tableCustomers.editable.cluster = ''
                  } else {
                    context.getFSOfficers(context.tableCustomers).finally(() => {
                      if (context.tableCustomers.editable.fsOfficer) {
                        context.tableCustomers.selected.fsOfficer = QUERY.find(context.tableCustomers.options.fsOfficers, {
                          id: context.tableCustomers.editable.fsOfficer
                        }) || ''

                        context.tableCustomers.editable.fsOfficer = ''
                      }
                    })
                  }
                })
              }
            })

            context.getProvinces(context.tableCustomers).finally(() => {
              if (context.tableCustomers.editable.province) {
                context.tableCustomers.selected.province = QUERY.find(context.tableCustomers.options.provinces, {
                  id: context.tableCustomers.editable.province
                }) || ''

                context.tableCustomers.editable.province = ''
              }
            })
          })
        }
      })
    })
  },

  middleware: [
    'auth',
    'audit'
  ],

  metaInfo: () => ({
    title: 'Customers'
  }),

  data () {
    return {
      state: {
        busy: false,
        editing: false,
        settings: false
      },
      tableCustomers: {
        busy: false,
        fetching: {
          provinces: false,
          municipalities: false,
          areas: false,
          clusters: false,
          fsOfficers: false
        },
        options: {
          statuses: ['All', 'New', 'Verified'],
          provinces: [],
          municipalities: [],
          areas: [],
          clusters: [],
          fsOfficers: []
        },
        editable: {
          status: '',
          province: '',
          municipality: '',
          area: '',
          cluster: '',
          fsOfficer: ''
        },
        selected: {
          tagging: 1,
          area: '',
          province: '',
          municipality: '',
          cluster: '',
          fsOfficer: ''
        },
        filter: {
          search: '',
          status: 'All',
          area: '',
          cluster: '',
          officer: '',
          province: '',
          municipality: '',
          has_farm: 0,
          has_crops: 0
        },
        filterOn: [],
        stacked: 'sm',
        sortBy: 'id',
        sortDesc: false,
        sortDirection: 'asc',
        pageOptions: [10, 25, 50, 100],
        currentPage: 0,
        totalRows: 0,
        perPage: 10,
        fields: [
          { mobile: 0, key: 'index', label: '#', class: 'text-right stacked-full text-md-center' },
          { mobile: 7, key: 'action', class: 'text-center w-md-125px' },
          { mobile: 1, key: 'name', label: 'Name', class: 'min-w-md-250px', formatter: this.getFullName, sortable: true },
          { mobile: 3, key: 'province.province_name', label: 'Province', class: 'min-w-250px' },
          { mobile: 4, key: 'municipality.municipality_name', label: 'Municipality', class: 'min-w-250px' },
          { mobile: 5, key: 'status', label: 'Status', class: 'min-w-80px text-right text-md-center' },
          { mobile: 6, key: 'updated_at', class: 'min-w-175px', formatter: this.dateTimeShortFormatter }
        ].sort(this.scaleOnMobile)
      }
    }
  },

  computed: {
    ...mapGetters({
      currentUser: 'auth/user'
    }),

    settingFilters () {
      const hasEditables = Object.keys(this.tableCustomers.editable).map(
        editableKey => this.tableCustomers.editable[editableKey]
      ).some(val => String(val) !== '')

      return hasEditables
    }
  },

  watch: {
    'tableCustomers.selected.area' (area) {
      this.tableCustomers.filter.area = area?.id || ''
    },

    'tableCustomers.selected.cluster' (cluster) {
      this.tableCustomers.filter.cluster = cluster?.id || ''
    },

    'tableCustomers.selected.fsOfficer' (fsOfficer) {
      this.tableCustomers.filter.officer = fsOfficer?.id || ''
    },

    'tableCustomers.selected.province' (province) {
      this.tableCustomers.filter.province = province?.id || ''
    },

    'tableCustomers.selected.municipality' (municipality) {
      this.tableCustomers.filter.municipality = municipality?.id || ''
    },

    'tableCustomers.filter.area' (area) {
      this.getClusters(this.tableCustomers, '', area).finally(() => {
        if (this.tableCustomers.editable.cluster) {
          this.tableCustomers.selected.cluster = QUERY.find(this.tableCustomers.options.clusters, {
            id: this.tableCustomers.editable.cluster
          }) || ''

          this.tableCustomers.editable.cluster = ''
        }
      })
    },

    'tableCustomers.filter.cluster' (cluster) {
      this.getFSOfficers(this.tableCustomers, '', this.tableCustomers.filter.area, cluster).finally(() => {
        if (this.tableCustomers.editable.fsOfficer) {
          this.tableCustomers.selected.fsOfficer = QUERY.find(this.tableCustomers.options.fsOfficers, {
            id: this.tableCustomers.editable.fsOfficer
          }) || ''

          this.tableCustomers.editable.fsOfficer = ''
        }
      })
    },

    'tableCustomers.filter.province' (province) {
      this.getMunicipalities(this.tableCustomers, '', province).finally(() => {
        if (this.tableCustomers.editable.municipality) {
          this.tableCustomers.selected.municipality = QUERY.find(this.tableCustomers.options.municipalities, {
            id: this.tableCustomers.editable.municipality
          }) || ''

          this.tableCustomers.editable.municipality = ''
        }
      })
    }
  },

  methods: {
    customerStatus (status) {
      switch (status) {
        case 'Verified': {
          return 'secondary'
        }
        case 'New': {
          return 'primary'
        }
        default: {
          return 'warning'
        }
      }
    },

    async tableProvider ({ currentPage, perPage, sortBy, sortDesc, filter }) {
      if (this.settingFilters) {
        return []
      }

      this.tableCustomers.busy = true

      const payload = {
        page: currentPage,
        per_page: perPage,
        sort: sortBy,
        sort_desc: sortDesc,
        filter_text: filter.search,
        filter_status: filter.status,
        area_id: filter.area,
        cluster_id: filter.cluster,
        creator_id: filter.officer,
        province_id: filter.province,
        municipality_id: filter.municipality,
        has_farm: filter.has_farm,
        has_crops: filter.has_crops
      }

      return await SAuditCustomer.get(payload).then(
        ({ data }) => {
          this.tableCustomers.totalRows = data.total_rows
          setTableOptions({
            currentPage,
            perPage,
            sortBy,
            sortDesc,
            filter,
            totalRows: data.total_rows
          })
          return data.items
        }
      ).catch(
        () => {
          this.tableCustomers.totalRows = 0
          setTableOptions({
            currentPage,
            perPage,
            sortBy,
            sortDesc,
            filter,
            totalRows: 0
          })
          return []
        }
      ).finally(() => {
        this.tableCustomers.busy = false
      })
    },

    async searchFilterAreas (search, loading) {
      this.searchAreasProvider(this.tableCustomers, search, loading)
    },

    async searchFilterClusters (search, loading) {
      this.searchClustersProvider(this.tableCustomers, search, loading)
    },

    async searchFilterFSOfficers (search, loading) {
      this.searchFSOfficersProvider(this.tableCustomers, search, loading)
    },

    async searchFilterProvinces (search, loading) {
      this.searchProvincesProvider(this.tableCustomers, search, loading)
    },

    async searchFilterMunicipalities (search, loading) {
      this.searchMunicipalitiesProvider(this.tableCustomers, search, loading)
    }
  }
}
</script>
